<template>
  <div id="navbar">
    <v-app-bar app fixed elevation="5" color="white">
      <v-app-bar-nav-icon @click="drawer = !drawer" class></v-app-bar-nav-icon>
      <!-- icon and welcome user -->
      <div class="d-flex align-center">
        <router-link to="/">
          <v-img
            class="ml-3 hidden-sm-and-down"
            max-width="60px"
            src="../assets/logo.svg"
          ></v-img>
        </router-link>
        <div
          class="body-1 pl-2 pl-md-5 font-weight-bold align-center"
          v-if="user"
        >
          <p class="ma-0">
            Balance:
            {{ user ? user.Balance : "" }}
          </p>
        </div>
      </div>

      <v-spacer></v-spacer>

      <!-- different website icons open menu -->
      <v-menu transition="slide-x-transition" bottom right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">
            <v-icon>mdi-apps</v-icon>
          </v-btn>
        </template>
        <v-list class="pa-0 ma-0" v-for="(item, i) in menuIcons" :key="i">
          <v-list-item class="hover-effect ma-0 pa-0">
            <a
              class="text-center grey--text text--darken-3"
              :href="item.url"
              target="_blank"
            >
              <v-img max-width="90px" :src="item.img"></v-img>
              <p>
                {{ item.name }}
              </p>
            </a>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- Mobile Logo -->
      <router-link to="/">
        <v-img
          class="ml-3 mr-5 hidden-md-and-up"
          max-width="60px"
          src="../assets/logo.svg"
        ></v-img
      ></router-link>

      <!-- Desktop menu buttons -->
      <div class="hidden-sm-and-down">
        <div v-if="isAuthenticated">
          <v-btn class="mx-2" color="primary" @click="showBuyMoreTokensModal()">
            <span>Purchase Tokens</span>
            <v-icon right>mdi-currency-usd-circle-outline</v-icon>
          </v-btn>
        </div>
        <div v-else>
          <v-btn class="mx-1 primary" link :href="cfg.LOGIN_URL">
            <span>Sign In</span>
            <v-icon right>mdi-login</v-icon>
          </v-btn>
        </div>
      </div>
    </v-app-bar>
    <PaymentMethodModal />

    <v-navigation-drawer v-model="drawer" temporary fixed>
      <v-list>
        <v-list-item-group>
          <v-list-item router to="/">
            <v-list-item-icon>
              <v-icon right>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider></v-divider>
      <!-- private links -->
      <v-list v-if="isAuthenticated">
        <v-list-item-group>
          <v-list-item
            v-for="link in privateLinks"
            :key="link.icon"
            router
            :to="link.route"
          >
            <v-list-item-icon>
              <v-icon right>{{ link.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <!-- public links and login/logout -->
      <v-list>
        <v-list-item-group v-if="isAuthenticated">
          <v-list-item link :href="cfg.LOGOUT_URL" @click="clearLocalStorage">
            <v-list-item-icon>
              <v-icon right>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Sign out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group v-else>
          <v-list-item
            v-for="link in publicLinks"
            :key="link.icon"
            router
            :to="link.route"
          >
            <v-list-item-icon>
              <v-icon right>{{ link.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :href="cfg.LOGIN_URL">
            <v-list-item-icon>
              <v-icon right>mdi-login</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Login</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import cfg from "@/cfg";
import PaymentMethodModal from "@/components/modalPaymentMethod";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapState([
      "user",
      "isAuthenticated",
    ]),
    ...mapGetters([
      "hasDefaultPaymentMethod",
    ]),
    registerURL() {
      if (this.$store.getters.referralId !== null) {
        return (
          this.$cfg.REGISTER_URL +
          "?referral_inviter=" +
          this.$store.getters.referralId
        );
      } else {
        return this.$cfg.REGISTER_URL;
      }
    },
  },
  components: {
    PaymentMethodModal,
  },
  data() {
    return {
      cfg: cfg,
      drawer: false,
      logged: false,
      publicLinks: [
        {
          route: "/how-it-works",
          icon: "mdi-information",
          text: "How it Works",
        },
        {
          route: "/customer-stories",
          icon: "mdi-account-voice",
          text: "Customer stories",
        },
      ],
      privateLinks: [
        {
          icon: "mdi-currency-usd-circle-outline",
          text: "Purchase Tokens",
          route: "/purchase-tokens",
        },
        {
          icon: "mdi-account-circle",
          text: "Profile",
          route: "/profile",
        },
        {
          icon: "mdi-bullseye-arrow",
          text: "Won Auctions",
          route: "/auctions-won",
        },
        {
          icon: "mdi-credit-card",
          text: "Payment Methods",
          route: "/payment-methods",
        },
        {
          icon: "mdi-cursor-default-click",
          text: "Redeem coupon",
          route: "/redeem-coupon",
        },
        {
          icon: "mdi-account-star-outline",
          text: "Refer a Friend",
          route: "/referrals",
        },
      ],
      menuIcons: [
        {
          name: "Account",
          img: require("../assets/PjiliAccounts.svg"),
          url: cfg.ACCOUNTS_UI_PROFILE,
        },
        {
          name: "Pjili plus",
          img: require("../assets/PjiliPlus.svg"),
          url: cfg.PJILI_PLUS_UI_URL,
        },
      ],
    };
  },
  methods: {
    ...mapActions(["addNotification"]),
    showBuyMoreTokensModal() {
      if (this.hasDefaultPaymentMethod) {
        this.$store.dispatch("showBuyTokensDialog");
      } else {
        this.$store.dispatch("showPaymentMethodDialog");
      }
    },
    clearLocalStorage() {
      window.localStorage.removeItem("auctionsStore");
    },
  },
};
</script>

<style lang="scss">
.hover-effect {
  background-color: #fff !important;
  transition: all 0.3s;
}
.hover-effect:hover {
  background-color: #eee !important;
  transition: all 0.3s;
}
</style>
